<!-- 时间选择 -->
<template>
  <div class="TimeSelect">
    <!-- 保存当天模板 -->
    <el-dialog
      :title="MoveandCopyTime.type"
      :visible.sync="MoveandCopyTime.show"
      width="600px"
    >
      <div class="BoyContent">
        <div class="title"><span>*</span> {{ $t('lang.startFrom') }}</div>
        <div class="selectTime">
          <el-date-picker
            type="datetime"
            v-model="StartFrom"
            popper-class="pick_date_time"
            :picker-options="pickerDateStart"
            :placeholder="$t('lang.selectData')"
            value-format="timestamp"
            format="yyyy-MM-dd h:mm:ss A"
            @change="TimeChange"
          >
          </el-date-picker>
        </div>
        <div class="Hint" v-if="ShowFollowOnHint">
          {{$t('lang.modeChange')}}
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="MoveandCopyTime.show = false">{{
          $t("lang.cancel")
        }}</el-button>
        <el-button
          type="primary"
          :loading='MoveandCopyTime.loading'
          @click="ApplyTime">{{
            $t("lang.apply")
          }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    MoveandCopyTime: {
      type: Object,
      default: () => ({
        type: 'Move',
        show: false,
        loading: false
      })
    },
    PitchEventList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      StartFrom: null,
      //   时间选择限制
      pickerDateStart: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(`${date.year}-${date.month}-${date.day} 00:00:00`).getTime()
          )
        }
      },
      // 参数列表
      paramList: '',
      // 是否是followOn事件
      multipleModelType: false,
      // 是否显示followOn提示
      ShowFollowOnHint: false,
      programId: ''
    }
  },
  created () {},
  mounted () {
    this.programId = this.$BehaviorSyns.getProgramId()
    this.multiOperationParam()
  },
  methods: {
    // 确定时间
    ApplyTime () {
      if (this.StartFrom) {
        this.$emit('ApplyStartFrom', this.StartFrom, this.ShowFollowOnHint)
      } else {
        this.$message.info(this.$t('lang.StartTimeEmpty'))
      }
    },
    // 时间变化
    TimeChange () {
      if (this.multipleModelType) {
        this.MoveandCopyTime.loading = true
        this.axios.post(Outil.getUrl('/event/checkExistEventByTime'), {
          programId: this.programId,
          time: this.StartFrom
        })
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.ShowFollowOnHint = !res.data.result
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
            this.MoveandCopyTime.loading = false
          }).catch((res) => {
            this.MoveandCopyTime.loading = false
          })
      }
    },
    // 是否是FollowOn
    multiOperationParam () {
      if (this.PitchEventList.length > 0) {
        const event = this.PitchEventList[0]
        if (event.multipleModelType) {
          this.multipleModelType = true
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.TimeSelect {
  .BoyContent {
    text-align: left;
    .title {
      color: #fff;
      span {
        color: #f56c6c;
      }
    }
    .selectTime {
      margin-top: 10px;
      ::v-deep.el-input__inner {
        width: 520px;
        height: 40px;
        padding-left: 10px;
        color: #dfdfdf;
        background: #444;
      }
      ::v-deep .el-input__prefix {
        .el-icon-time{
          display: none;
        }
      }
    }
    .Hint {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #E56464;
      margin-top: 15px;
    }
  }
  ::v-deep.el-dialog__wrapper .el-dialog .el-dialog__footer {
    padding: 10px 20px 30px;
    .dialog-footer {
      text-align: right;
    }
  }
}
</style>
